const inPageNav = () => {
  function findPos(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);
      return [curtop - 50];
    }
  };

  document.querySelectorAll('.element-elementalnav__item a').forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault();
      const targetID = event.target.dataset.target;
      const targetElement = document.querySelector(targetID);
      window.scroll(0, findPos(targetElement));
      let pageURL = window.location.href;

      if (window.location.href.indexOf('#') > -1) {
        pageURL = window.location.href.replace(window.location.href.substr(window.location.href.indexOf('#'), window.location.href.length), '');
      }

      window.history.pushState({}, null, pageURL + targetID);
    });
  });
}

export default inPageNav;
